import React from "react"

import Layout from "../components/common/layout/layout"
import SEO from "../components/common/layout/seo"
import Navigation from "../components/common/navigation/navigation"
import { graphql, useStaticQuery, Link } from "gatsby"

import Header from "../components/sections/header"
import Features from "../components/sections/features"
import Footer from "../components/sections/footer"
import GetStarted from "../components/sections/getstarted"

const IndexPage = ({ data }) => {
  return (
    <Layout>
    
      <SEO title="Home" />
      <Navigation hide={true} data={data.background} />
      <Header />
      <Features />
      <GetStarted />
      <Footer />
    </Layout>
  )
}

export const data = graphql`
  query {
    background: file(
      sourceInstanceName: { eq: "product" }
      name: { eq: "logo" }
    ) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`

export default IndexPage
